export default __webpack_public_path__ + "static/SRF 0100 - Fiche de spécifications et données techniques-b8886afea890c07d8cd66d9e8b223eb9.pdf";